export default __webpack_public_path__ + "static/media/load-document.266dbd58.svg";